export default __webpack_public_path__ + "static/media/Trikato.ea44ed24.png";